<template>
<b-dropdown
  :toggle-class="dropdownToggleClass"
  :variant="variant"
  class="apply-inline-button"
  v-if="loaded"
>
  <template
    slot="button-content"
  >
    <ItpText
      :text="messages.noTemplateDefind"
      v-if="noItemDefined"
    >
    </ItpText>
    <ItpText
      :text="messages.selectTemplate"
      v-if="!noItemDefined && !selectedItem"
    >
    </ItpText>
    <DIV
      v-if="selectedItem"
    >
      <ItpText
        :muted="selectedItem.inactive"
        :strikethrough="selectedItem.inactive"
      >
        <span
          class="pr-1"
        >
          {{ selectedItem.name }} ({{ selectedItem.template_type }})
        </span>
      </ItpText>
    </DIV>
  </template>
  <b-dropdown-item-button
    :key="item.id"
    v-for="item in items"
    @click.prevent="evh_5962862420439144_clickPrevent($event, {item})"
  >
    <ItpText
      :muted="item.inactive"
      :strikethrough="item.inactive"
    >
      <strong>
        {{ item.name }} ({{ item.template_type }})
      </strong>
    </ItpText>
  </b-dropdown-item-button>
  <b-dropdown-divider
    v-if="!noItemDefined"
  >
  </b-dropdown-divider>
  <ItpNavItem
    href="#"
    dropdown-item
    icon="fa-plus"
    :text="messages.createTemplate"
    @click.prevent="evh_1048678296148443_clickPrevent($event, {})"
  >
  </ItpNavItem>
</b-dropdown>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcTemplateSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getSelectedItemId(...args: any[]) {
    if (this.$route.params && this.$route.params.id) {
      return this.$route.params.id;
    }
  }

  onItemSelected(...args: any[]) {
    const [item] = args;
    this.$router.push({
      name: 'app.templates.template',
      params: { id: item.id }
    })
  }

  onItemCreated(...args: any[]) {
    console.log('onItemCreated', args);
  }

  @Prop({
    type: String,
  })
  cacheKey!: string;

  @Watch('cacheKey')
  onCache_key(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("cacheKey")
  }

  @Prop({
    type: String,
  })
  companyId!: string;

  @Watch('companyId')
  onCompany_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("companyId")
  }

  @Prop({
    type: String,
    default: "light",
  })
  variant!: string;

  @Watch('variant')
  onVariant(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("variant")
  }

  @Prop({
    type: String,
  })
  toggleClass!: string;

  @Watch('toggleClass')
  onToggle_class(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("toggleClass")
  }

  messages!: any;
  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_template').then(d => _.sortBy(d, 'created_at'))
  }

  oid!: any;

  async $$load_oid() {
    return this.getSelectedItemId()
  }

  selectedItem!: any;

  async $$load_selectedItem() {
    return _.find(this.$data.items, { id: this.oid })
  }

  ux!: any;
  dataMembers = ['messages', 'items', 'oid', 'selectedItem', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          noTemplateDefined: this.$fn.pgettext("TemplateSelector", "No template have been defined yet"),
          selectTemplate: this.$fn.pgettext("TemplateSelector", "Select template"),
          createTemplate: this.$fn.pgettext("TemplateSelector", "Create template..."),
        }
        ,
        items: null,
        oid: null,
        selectedItem: null,
        ux: null,
      },
    }
  }

  get noItemDefined() {
    if (this.loaded) {

      return !this.items.length
    }
    return null;
  }

  get dropdownToggleClass() {
    if (this.loaded) {

      return 'border ' + (this.toggleClass || '')
    }
    return null;
  }

  async act_5962862420439144_setData_4890_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5962862420439144_setData_4890, alias=undefined
    return {
      path: "selectedItem",
      value: this.onItemSelected($event.scope.item),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5962862420439144_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_clickPrevent.executeFromDOM(this, event, scope);
  }

  async act_1048678296148443_script_4894_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1048678296148443_script_4894, alias=undefined
    this.onItemCreated($event.data)
  }

  async act_1048678296148443_script_4894_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1048678296148443_script_4894, alias=undefined
    return {
      value: () => this.act_1048678296148443_script_4894_getActionArgs_value($event),
    }
  }

  async evh_1048678296148443_close_4893_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1048678296148443_close_4893, alias=undefined
    return $event.data.modalResult.value
  }

  async act_1048678296148443_showModal_4892_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1048678296148443_showModal_4892, alias=undefined
    return {
      name: "CreateTemplate",
    }
  }

  async evh_1048678296148443_clickPrevent(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1048678296148443_clickPrevent.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_setData_4890: actions.SetDataAction;
    evh_5962862420439144_clickPrevent_4889: actions.EventHandlerImpl;
    evh_5962862420439144_clickPrevent: actions.EventHandlerGroup;
    act_1048678296148443_script_4894: actions.ScriptAction;
    evh_1048678296148443_close_4893: actions.EventHandlerImpl;
    act_1048678296148443_showModal_4892: actions.ShowModalAction;
    evh_1048678296148443_clickPrevent_4891: actions.EventHandlerImpl;
    evh_1048678296148443_clickPrevent: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_setData_4890 = new actions.SetDataAction(
      {
        actionArgs: this.act_5962862420439144_setData_4890_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_clickPrevent_4889 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_setData_4890,
        event: "click.prevent",
        displayName: "setData",
      }
    );
    const evh_5962862420439144_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_clickPrevent_4889],
      }
    );
    const act_1048678296148443_script_4894 = new actions.ScriptAction(
      {
        actionArgs: this.act_1048678296148443_script_4894_getActionArgs,
        events: [],
      }
    );
    const evh_1048678296148443_close_4893 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_script_4894,
        event: "close",
        when: this.evh_1048678296148443_close_4893_getWhen,
        displayName: "script",
      }
    );
    const act_1048678296148443_showModal_4892 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1048678296148443_showModal_4892_getActionArgs,
        events: [evh_1048678296148443_close_4893],
      }
    );
    const evh_1048678296148443_clickPrevent_4891 = new actions.EventHandlerImpl(
      {
        action: act_1048678296148443_showModal_4892,
        event: "click.prevent",
        displayName: "showModal",
      }
    );
    const evh_1048678296148443_clickPrevent = new actions.EventHandlerGroup(
      {
        handlers: [evh_1048678296148443_clickPrevent_4891],
      }
    );
    return {
      act_5962862420439144_setData_4890,
      evh_5962862420439144_clickPrevent_4889,
      evh_5962862420439144_clickPrevent,
      act_1048678296148443_script_4894,
      evh_1048678296148443_close_4893,
      act_1048678296148443_showModal_4892,
      evh_1048678296148443_clickPrevent_4891,
      evh_1048678296148443_clickPrevent,
    }
  }
}

Vue.component("UcTemplateSelector", UcTemplateSelector);

</script>